import { jsxs as r, jsx as o } from "react/jsx-runtime";
const t = (l) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ...l,
    children: [
      /* @__PURE__ */ r("g", { clipPath: "url(#microsoft365-colored_svg__a)", children: [
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#microsoft365-colored_svg__b)",
            d: "m13.773 4.56-.122.074q-.293.178-.55.394l.353-.25h3L17 8.91l-2.727 2.727-2.727 1.896v2.186c0 1.527.797 2.942 2.104 3.733l2.87 1.738-6.065 3.538h-1.17l-2.181-1.32A4.36 4.36 0 0 1 5 19.675v-7.35c0-1.527.798-2.943 2.105-3.734l6.546-3.959q.06-.037.122-.071"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#microsoft365-colored_svg__c)",
            d: "m13.773 4.56-.122.074q-.293.178-.55.394l.353-.25h3L17 8.91l-2.727 2.727-2.727 1.896v2.186c0 1.527.797 2.942 2.104 3.733l2.87 1.738-6.065 3.538h-1.17l-2.181-1.32A4.36 4.36 0 0 1 5 19.675v-7.35c0-1.527.798-2.943 2.105-3.734l6.546-3.959q.06-.037.122-.071"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#microsoft365-colored_svg__d)",
            d: "M20.273 13.273v2.444a4.36 4.36 0 0 1-2.104 3.733l-6.546 3.962a4.36 4.36 0 0 1-4.367.087l6.393 3.87c1.39.841 3.13.841 4.52 0l6.545-3.962a4.36 4.36 0 0 0 2.104-3.733V17.91l-.545-.818z"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#microsoft365-colored_svg__e)",
            d: "M20.273 13.273v2.444a4.36 4.36 0 0 1-2.104 3.733l-6.546 3.962a4.36 4.36 0 0 1-4.367.087l6.393 3.87c1.39.841 3.13.841 4.52 0l6.545-3.962a4.36 4.36 0 0 0 2.104-3.733V17.91l-.545-.818z"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#microsoft365-colored_svg__f)",
            d: "m24.713 8.59-6.546-3.96a4.36 4.36 0 0 0-4.386-.075l-.13.079a4.36 4.36 0 0 0-2.106 3.734v5.173l2.106-1.274a4.36 4.36 0 0 1 4.517 0l6.545 3.96a4.36 4.36 0 0 1 2.103 3.59l.002-.143v-7.35a4.36 4.36 0 0 0-2.105-3.734"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#microsoft365-colored_svg__g)",
            d: "m24.713 8.59-6.546-3.96a4.36 4.36 0 0 0-4.386-.075l-.13.079a4.36 4.36 0 0 0-2.106 3.734v5.173l2.106-1.274a4.36 4.36 0 0 1 4.517 0l6.545 3.96a4.36 4.36 0 0 1 2.103 3.59l.002-.143v-7.35a4.36 4.36 0 0 0-2.105-3.734"
          }
        )
      ] }),
      /* @__PURE__ */ r("defs", { children: [
        /* @__PURE__ */ r(
          "radialGradient",
          {
            id: "microsoft365-colored_svg__b",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "rotate(110.528 3.14 8.627)scale(18.1995 31.7436)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.064, stopColor: "#AE7FE2" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#0078D4" })
            ]
          }
        ),
        /* @__PURE__ */ r(
          "radialGradient",
          {
            id: "microsoft365-colored_svg__d",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(16.75623 -2.46453 1.628 11.06862 8.507 22.737)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.134, stopColor: "#D59DFF" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#5E438F" })
            ]
          }
        ),
        /* @__PURE__ */ r(
          "radialGradient",
          {
            id: "microsoft365-colored_svg__f",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "rotate(-165.772 13.69 7.11)scale(13.5943 22.8847)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.058, stopColor: "#50E6FF" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#436DCD" })
            ]
          }
        ),
        /* @__PURE__ */ r(
          "linearGradient",
          {
            id: "microsoft365-colored_svg__c",
            x1: 12.37,
            x2: 9.773,
            y1: 23.565,
            y2: 19.073,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#114A8B" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#0078D4", stopOpacity: 0 })
            ]
          }
        ),
        /* @__PURE__ */ r(
          "linearGradient",
          {
            id: "microsoft365-colored_svg__e",
            x1: 24.831,
            x2: 22.048,
            y1: 16.751,
            y2: 20.741,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#493474" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#8C66BA", stopOpacity: 0 })
            ]
          }
        ),
        /* @__PURE__ */ r(
          "linearGradient",
          {
            id: "microsoft365-colored_svg__g",
            x1: 12.078,
            x2: 16.175,
            y1: 4.576,
            y2: 4.576,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#2D3F80" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#436DCD", stopOpacity: 0 })
            ]
          }
        ),
        /* @__PURE__ */ o("clipPath", { id: "microsoft365-colored_svg__a", children: /* @__PURE__ */ o("path", { fill: "#fff", d: "M5 4h21.818v24H5z" }) })
      ] })
    ]
  }
);
export {
  t as default
};
